<script setup lang="ts">
// COMPOSABLES
const route = useRoute();
const { locale, isDefaultLocale } = useTypedI18n();

// DATA
const { story, error } = await useAsyncStoryblok(resolveStoryblokSlug(route.params.slug), {
    api: {
        ...(!isDefaultLocale.value ? { language: locale.value } : {}),
        version: 'published',
        resolve_links: 'url', // @see: https://www.storyblok.com/cl/url-resolving
        resolve_relations: 'storyblok-blog-post.categories',
    },
    bridge: {},
});
const publishedAt = computed(() => story.value.first_published_at);

if (!story.value || error.value) {
    throw createError({ status: 404 });
}

// TRACKING
const { setStoryblokPageType } = useStoryblokTrackingPageType();
setStoryblokPageType(story.value.full_slug);

// SEO
useStoryblokSeoMeta(story);
</script>

<template>
    <StoryblokComponent v-if="story" :blok="story.content" :published-at="publishedAt" />
</template>
